import { __extends } from "tslib";
import React from 'react';
import throttle from 'lodash/throttle';
export var DISTANCE_UNIT;
(function (DISTANCE_UNIT) {
    DISTANCE_UNIT["PX"] = "PX";
    DISTANCE_UNIT["WINDOW_HEIGHT"] = "WINDOW_HEIGHT";
})(DISTANCE_UNIT || (DISTANCE_UNIT = {}));
var THROTTLE_TIMEOUT = 250;
var OnScrollBottom = /** @class */ (function (_super) {
    __extends(OnScrollBottom, _super);
    function OnScrollBottom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.childNodeRef = React.createRef();
        _this.rememberScrollTop = function () {
            _this.prevScrollTop = window.scrollY;
        };
        _this.callOnScrolledToBottom = throttle(function () {
            return requestAnimationFrame(function () {
                var onScrolledToBottom = _this.props.onScrolledToBottom;
                if (!onScrolledToBottom) {
                    return;
                }
                if (!window.document.body.scrollHeight) {
                    return;
                }
                if (_this.getDistanceToBottom() <=
                    _this.getDistanceToBottomWhenShouldTrigger()) {
                    var scrollDelta = window.scrollY - _this.prevScrollTop || 0;
                    onScrolledToBottom(scrollDelta);
                }
                _this.rememberScrollTop();
            });
        }, THROTTLE_TIMEOUT);
        return _this;
    }
    OnScrollBottom.prototype.componentDidMount = function () {
        window && window.addEventListener('scroll', this.callOnScrolledToBottom);
        if (this.props.checkOnMount) {
            this.callOnScrolledToBottom();
        }
    };
    OnScrollBottom.prototype.componentDidUpdate = function () {
        if (this.props.checkOnUpdate) {
            this.callOnScrolledToBottom();
        }
    };
    OnScrollBottom.prototype.componentWillUnmount = function () {
        window && window.removeEventListener('scroll', this.callOnScrolledToBottom);
    };
    OnScrollBottom.prototype.render = function () {
        var children = this.props.children;
        if (!children) {
            return null;
        }
        return React.cloneElement(children, { ref: this.childNodeRef });
    };
    OnScrollBottom.prototype.getDistanceToBottomWhenShouldTrigger = function () {
        var _a = this.props, distanceToBottom = _a.distanceToBottom, distanceUnit = _a.distanceUnit;
        if (distanceUnit === DISTANCE_UNIT.PX) {
            return distanceToBottom;
        }
        return distanceToBottom * window.innerHeight;
    };
    OnScrollBottom.prototype.getDistanceToBottom = function () {
        var children = this.props.children;
        if (children) {
            var childNode = this.childNodeRef.current;
            if (!childNode) {
                return 0;
            }
            // this child bottom position is relative to the top of the view port
            var childBottom = childNode.getBoundingClientRect().bottom;
            // we are interestedin the distance from the bottom of the view port to the child bottom
            var distanceToChildBottom = childBottom - window.innerHeight;
            return distanceToChildBottom;
        }
        var distanceToScrollContainerBottom = window.document.body.scrollHeight - window.scrollY - window.innerHeight;
        return distanceToScrollContainerBottom;
    };
    return OnScrollBottom;
}(React.Component));
export default OnScrollBottom;
//# sourceMappingURL=OnScrollBottom.js.map